export const FORCE_UPDATE_ERROR_MESSAGE = 'Force update required'
export const FORCE_UPDATE_ERROR_STATUS = 403

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=asofix.frontend.app'
export const APP_STORE_URL = 'https://apps.apple.com/app/id6757765606'
